// Persists a chat message to the same Conversation/Message backing store that regular chat uses
// (via the shared "conversation_id" localStorage key), so messages pushed by any chatbot sub-flow
// (Program Matrix wizard, Sustainability evidence upload, module classification) show up in
// "View Chat History" instead of only living in component state.
//
// The queue is module-scoped (not per-component) on purpose: multiple chatbot sub-flows can each
// push a message in quick succession, and MessagesController#create always creates a BRAND NEW
// Conversation when conversation_id is blank rather than finding-or-creating one. Without a single
// shared queue, two near-simultaneous calls could both read a stale (blank) conversation_id from
// localStorage before either response has written the newly-created one back, splitting the two
// messages across separate Conversations instead of one. Chaining every call onto the previous
// call's promise guarantees each request only fires once the prior one's response (and its
// localStorage write) has landed, regardless of which sub-flow triggered it.
let persistQueue = Promise.resolve()

const persistMessage = (msg) => {
  if (!msg.content) return
  persistQueue = persistQueue.then(
    () => new Promise((resolve) => {
      const conversationId = localStorage.getItem("conversation_id") || null
      APIClient.post(
        "/messages",
        {
          conversation_id: conversationId,
          role: msg.role,
          content: msg.content,
          title: msg.content,
        },
        (response) => {
          if (response.conversation_id) {
            localStorage.setItem("conversation_id", response.conversation_id)
          }
          resolve()
        },
        () => resolve(),
      )
    }),
  )
}

export default persistMessage
